import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3460a472"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "manual disabled-loader"
};
const _hoisted_2 = {
  key: 1,
  class: "manual-data"
};
const _hoisted_3 = {
  key: 0,
  class: "manual-empty"
};
const _hoisted_4 = {
  key: 1,
  class: "manual-value-row"
};
const _hoisted_5 = ["id"];
const _hoisted_6 = {
  class: "manual-value-icon"
};
const _hoisted_7 = {
  class: "popover-content"
};
const _hoisted_8 = {
  class: "popover-title"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popover-title-text"
}, "Over stocking alert", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popover-text"
}, " The proposed quantity exceeds 1,5x the forecasted amount. ", -1));
const _hoisted_11 = {
  class: "popover-content"
};
const _hoisted_12 = {
  class: "popover-title"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popover-title-text"
}, "Under stocking alert", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popover-text"
}, " The proposed quantity is less than 0.5x the forecasted amount. ", -1));
const _hoisted_15 = {
  class: "manual-value"
};
const _hoisted_16 = {
  key: 2,
  class: "manual-days"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_popover = _resolveComponent("app-popover");
  return $props.manualOverrideTaskRunning ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_app_icon, {
    icon: "upload-processing-icon-new",
    size: 20
  })])) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(['manual', {
      purple: $data.value > 0 && !$props.slowMover,
      yellow: $props.slowMover
    }]),
    onClick: _cache[6] || (_cache[6] = _withModifiers((...args) => $options.onClick && $options.onClick(...args), ["stop"]))
  }, [$data.edit ? _withDirectives((_openBlock(), _createElementBlock("input", {
    key: 0,
    ref: "inputRef",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.value = $event),
    type: "number",
    class: "manual-input",
    onWheel: _cache[1] || (_cache[1] = e => {
      e.preventDefault();
    }),
    onBlur: _cache[2] || (_cache[2] = (...args) => $options.onBlur && $options.onBlur(...args)),
    onKeyup: [_cache[3] || (_cache[3] = _withKeys((...args) => $options.onBlur && $options.onBlur(...args), ["enter"])), _cache[4] || (_cache[4] = _withKeys((...args) => $options.onBlur && $options.onBlur(...args), ["esc"]))]
  }, null, 544)), [[_vModelText, $data.value]]) : (_openBlock(), _createElementBlock("div", _hoisted_2, [!$props.item.manual_override ? (_openBlock(), _createElementBlock("div", _hoisted_3, "+ Override")) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", {
    class: "manual-close",
    id: `${$data.id}-close`,
    onClick: _cache[5] || (_cache[5] = _withModifiers((...args) => $options.onClear && $options.onClear(...args), ["stop"]))
  }, [_createVNode(_component_app_icon, {
    icon: "cross",
    size: 16,
    color: "#4D4D4D"
  })], 8, _hoisted_5), _createVNode(_component_app_popover, {
    target: `${$data.id}-close`,
    placement: "bottom"
  }, {
    default: _withCtx(() => [_createTextVNode(" Clear value ")]),
    _: 1
  }, 8, ["target"]), _createElementVNode("div", _hoisted_6, [$options.isOver ? (_openBlock(), _createBlock(_component_app_icon, {
    key: 0,
    id: `${$data.id}-over`,
    icon: "over"
  }, null, 8, ["id"])) : _createCommentVNode("", true), $options.isUnder ? (_openBlock(), _createBlock(_component_app_icon, {
    key: 1,
    id: `${$data.id}-under`,
    icon: "under"
  }, null, 8, ["id"])) : _createCommentVNode("", true), _createVNode(_component_app_popover, {
    target: `${$data.id}-over`,
    placement: "bottom"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_app_icon, {
      icon: "over",
      color: "#fff"
    }), _hoisted_9]), _hoisted_10])]),
    _: 1
  }, 8, ["target"]), _createVNode(_component_app_popover, {
    target: `${$data.id}-under`,
    placement: "bottom"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_app_icon, {
      icon: "under",
      color: "#fff"
    }), _hoisted_13]), _hoisted_14])]),
    _: 1
  }, 8, ["target"]), _createElementVNode("div", _hoisted_15, _toDisplayString($data.value), 1)])]))])), $data.value > 0 && $options.days > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString($options.days) + "D", 1)) : _createCommentVNode("", true)], 2));
}